import { FinancePaymentStatus } from 'chaika-enums';

export const enum PaymentEvent {
    StatusUpdated = 'PaymentStatusUpdated',
}

export interface PaymentStatusUpdatedData {
    body: {
        status: FinancePaymentStatus;
        errorMessage?: string;
    };
    name: PaymentEvent;
    entityId: string;
    entityType: 'Payment';
    occurredOn: string;
}
